export default __webpack_public_path__ + "static/media/HardCut-Preserve-01.009c08c2.jpg";